import React from 'react';

const AccountSelection = ({
  selectedAccount,
  setSelectedAccount,
  accounts,
}) => (
  <div className="filter">
    <div className="filter__field">
      <label className="filter__field-label">Account</label>
      {' '}
      <select
        className="filter__field-input"
        id="account"
        value={selectedAccount}
        onChange={(e) => setSelectedAccount(e.target.value)}
      >
        <option value="">-- Select an account --</option>
        {accounts?.map((account) => (
          <option key={`account-item-${account.id}`} value={account.id}>{account.name}</option>
        )) }
      </select>
    </div>
  </div>
);
export default AccountSelection;
